export const CONSTANT = {
  encodingType: [
    {
      label: 'UTF-8',
      value: 'UTF-8',
    },
    {
      label: 'WINDOWS-874',
      value: 'WINDOWS-874'
    }
  ]
};

export const SUPPORT_FORMAT = ['application/pdf'];

export const ITEMS_PER_PAGE_OPTIONS = [
  { label: '10',value: 10},
  { label: '40', value: 40 },
  { label: '100', value: 100 }
];

export const PAGINATION = {
  MAX_SIZE: 10,
  PAGE_SIZE: 40
};

export const DOC_TEMPLATES = [
  {
    name: 'ใบกำกับภาษี',
    nameEN: 'Tax Invoice',
    type: 'tax_invoice'
  },
  {
    name: 'ใบลดหนี้',
    nameEN: 'Credit Note',
    type: 'credit_note'
  },
  {
    name: 'ใบเพิ่มหนี้',
    nameEN: 'Debit Note',
    type: 'debit_note'
  }
];

export const DOC_TYPE = [
  {
    name: 'ใบกำกับภาษี',
    nameEN: 'Tax Invoice',
    type: 'tax_invoice'
  },
  {
    name: 'ใบลดหนี้',
    nameEN: 'Credit Note',
    type: 'credit_note'
  },
  {
    name: 'ใบเพิ่มหนี้',
    nameEN: 'Debit Note',
    type: 'debit_note'
  },
  {
    name: 'ใบแจ้งหนี้/ใบกำกับภาษี',
    nameEN: 'Invoice/Tax Invoice',
    type: 'invoice_tax_invoice'
  },
  {
    name: 'ใบเสร็จรับเงิน/ใบกำกับภาษี',
    nameEN: 'Receipt/Tax Invoice',
    type: 'receipt_tax_invoice'
  },
  {
    name: 'ใบเสร็จรับเงิน',
    nameEN: 'Receipt',
    type: 'receipt'
  },
];

export const RD_DOC_TYPE = {
    'tax_invoice': 'Tax Invoice',
    'credit_note': 'Credit Note',
    'debit_note': 'Debit Note',
    'invoice_tax_invoice': 'Invoice/Tax Invoice',
    'receipt_tax_invoice': 'Receipt/Tax Invoice'
  };

export const MODAL_CONFIG = {
  animated: true,
  class: 'modal-dialog-centered'
};

export const CALENDAR_LOCALE = {
  TH: {
    firstDayOfWeek: 0,
    dayNames: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
    dayNamesShort: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
    dayNamesMin: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
    monthNames: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
    monthNamesShort: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
    today: 'วันนี้',
    clear: 'ล้างข้อมูล'
  },
  EN: {
    firstDayOfWeek: 0,
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'],
    dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'],
    today: 'Today',
    clear: 'Clear'
  }
};

export const CUSTOMER_TYPES = [
  {
    name: 'นิติบุคคลในประเทศ',
    nameEN: 'Thailand Corporation',
    type: 'thailand_corporation',
    value: 0
  },
  {
    name: 'บุคคลธรรมดา',
    nameEN: 'Ordinary Person',
    type: 'ordinary_person',
    value: 2
  },
  {
    name: 'นิติบุคคลต่างประเทศ',
    nameEN: 'Foreign Corporation',
    type: 'foreign_corporation',
    value: 1
  },
  {
    name: 'บริษัทในเครือ',
    nameEN: 'Affiliated Corporation',
    type: 'affiliated_corporation',
    value: 3
  },
];

export const PURPOSES = {
    receipt_tax_invoice: [
    {label: 'ชื่อผิด', value: 'ชื่อผิด'},
    {label: 'ที่อยู่ผิด', value: 'ที่อยู่ผิด'},
    {label: 'ลูกค้าคืนสินค้าทั้งหมด', value: 'ลูกค้าคืนสินค้าทั้งหมด'},
    {label: 'ลูกค้าคืนสินค้าบางส่วน', value: 'ลูกค้าคืนสินค้าบางส่วน'},
  ],
  tax_invoice: [],
  credit_note: [
    {label: 'มีการเปลี่ยนราคาสินค้า', value: 'มีการเปลี่ยนราคาสินค้า'},
    {label: 'สินค้าชำรุด', value: 'สินค้าชำรุด'},
    {label: 'ส่งสินค้าไม่ครบ', value: 'ส่งสินค้าไม่ครบ'},
    {label: 'คำนวณราคาผิด', value: 'คำนวณราคาผิด'},
    {label: 'ลูกค้าคืนสินค้า', value: 'ลูกค้าคืนสินค้า'},
  ],
  debit_note: [
    {label: 'มีการเปลี่ยนราคาสินค้า', value: 'มีการเปลี่ยนราคาสินค้า'},
    {label: 'คำนวณราคาผิด', value: 'คำนวณราคาผิด'},
  ],
  // invoice: [
  //   {label: 'ชื่อผิด', value: 'ชื่อผิด'},
  //   {label: 'ที่อยู่ผิด', value: 'ที่อยู่ผิด'},
  // ],
  // receipt: [
  //   {label: 'ชื่อผิด', value: 'ชื่อผิด'},
  //   {label: 'ที่อยู่ผิด', value: 'ที่อยู่ผิด'},
  //   {label: 'ลูกค้าคืนสินค้าทั้งหมด', value: 'ลูกค้าคืนสินค้าทั้งหมด'},
  //   {label: 'ลูกค้าคืนสินค้าบางส่วน', value: 'ลูกค้าคืนสินค้าบางส่วน'},
  // ],
};



// WEBPACK FOOTER //
// /opt/app/src/app/services/constant.ts